'use client'

import { sendGTMEvent } from '@next/third-parties/google'
import { type FC, useEffect } from 'react'

type StoryblokExpertPageGtmProps = {
  event: object
}

export const StoryblokExpertPageGtm: FC<StoryblokExpertPageGtmProps> = ({
  event,
}) => {
  useEffect(() => {
    sendGTMEvent(event)
  }, [event])

  return null
}
